import styled from 'styled-components'

export const GlobalModalFooter = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-around;
    align-self: end;
`
